import React from 'react'
import { Button, Table, Col, Form, Row, Media } from 'reactstrap';
import { ConfigServer } from '../../data/config';
import { Dialog } from 'primereact/dialog';



export const ModalAuthorizationCash = (props) => {

    const { toogleAuthorization, modalAuthorization, _commercialLine, _nameUser, _branchName, _new, handleOpenPreview, handleClosedPreview, viewDetail, viewAmount, formatter, user, _admin_cash, id_cash, saveCourtesyPatient
    } = props;

    let _sum = 0


    return (
        <Dialog
            header={<label className='f-w-600'>Revisión de corte</label>}
            visible={modalAuthorization}
            onHide={toogleAuthorization}
            modal
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
                content: { style: { paddingLeft: "1px" } }
            }}
            footer={
                <>
                    {
                        _admin_cash === "True" && <>
                            <Button color='danger' onClick={toogleAuthorization}>Cancelar</Button>
                            <Button color='secondary' onClick={() => saveCourtesyPatient(_new, id_cash)}>Autorizar</Button>
                        </>
                    }
                    {
                        _admin_cash !== "True" && <>
                            <Button color='secondary' onClick={toogleAuthorization}>Aceptar</Button>
                        </>
                    }
                </>
            }
        >

            <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0 container-global-zoom'>
                <Form className="form theme-form" role="form">
                    {
                        _admin_cash === "True" && <Col sm="12">

                            <Row>

                                <Col sm="12">
                                    <Row>
                                        <Col sm="2">
                                        </Col>


                                        <Col sm="8" className='p-l-0 p-r-0' style={{ textAlign: "center" }} >
                                            <label className='f-14 f-w-600'>{_commercialLine} </label> <br />
                                            <label style={{ fontSize: "11px" }} className=' f-w-600'>{_branchName} </label> <br />


                                        </Col>
                                        <Col sm="2">
                                            <div className="media profile-media" >
                                                <img className="b-r-10  "
                                                    src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                                                    style={{ width: "100%" }}
                                                    alt="Logo" />
                                            </div>


                                        </Col>
                                    </Row>

                                    <Row>

                                    </Row>
                                    <div className='preview-cash-div' >
                                    </div> <br />
                                </Col>

                            </Row>
                            <Row>
                                <div
                                    style={{
                                        color: "#856404",
                                        fontSize: "0.78rem",
                                        marginTop: "6px",
                                        fontWeight: "500",
                                        backgroundColor: "#fff3cd",
                                        padding: "4px 10px",
                                        borderRadius: "6px",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        border: "1px solid #ffeeba",
                                    }}
                                >
                                    <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
                                    {"Autorizar corte que entrego el responsable." ?? "---"}
                                </div>
                                <Col sm="12" style={{ textAlign: "right" }}>
                                    <label onClick={viewDetail ? handleClosedPreview : handleOpenPreview} className='f-w-600 pointer' style={{ fontSize: "12px", textDecoration: "underline", color: "#495057" }} >{viewDetail ? "OCULTAR" : "DETALLE"}</label>
                                </Col>
                                {viewDetail && <Col sm="12">
                                    <Row>
                                        <Col sm="6">
                                            {/* <label htmlFor="">{user}</label> */}
                                            <Table striped size="sm">
                                                <thead>
                                                    <tr>
                                                        <th style={{ backgroundColor: "#3f9acdc4", color: "#fff", fontWeight: "bold" }}>Usuario responsable del corte</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ fontWeight: "bold" }} > <Media body className="rounded-circle" style={{ width: "10%" }} src={require("../../assets/images/loginHelenLabs/User/UserWoman.svg")} alt="" />{user}</td>
                                                    </tr>

                                                </tbody>

                                            </Table>
                                        </Col>
                                        <Col sm="6">
                                            <tr>
                                                <td colSpan="3">
                                                    <Table striped size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ backgroundColor: "#3f9acdc4", color: "#fff", fontWeight: "bold" }}>Métodos de Pagos Registrados</th>
                                                                <th style={{ backgroundColor: "#3f9acdc4", color: "#fff", fontWeight: "bold" }}>Montos</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {viewAmount.map((_pay, _k) => {
                                                                _sum += _pay.amount
                                                                let payMethodLabel;
                                                                switch (_pay?.id_pay_method) {
                                                                    case 1: payMethodLabel = "Efectivo";
                                                                        break;
                                                                    case 2: payMethodLabel = "Tarjeta de Crédito";
                                                                        break;
                                                                    case 4: payMethodLabel = "Tarjeta de Débito";
                                                                        break;
                                                                    case 8: payMethodLabel = "Transferencia Bancaria";
                                                                        break;
                                                                    case 10: payMethodLabel = "Crédito";
                                                                        break;
                                                                    default: payMethodLabel = "Desconocido";
                                                                        break;
                                                                }
                                                                return (
                                                                    <tr key={_k}>
                                                                        <td>{payMethodLabel}</td>
                                                                        <td style={{ textAlign: "right" }} className='f-w-600'>{formatter.format(_pay?.amount ?? 0)}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                        <tr>
                                                            <td style={{ color: "#000", textAlign: "end", fontWeight: "bold" }}>
                                                                {"Total"}
                                                            </td>
                                                            <td style={{ backgroundColor: '#000', color: "#fff", fontWeight: "bold", textAlign: "right" }}>
                                                                {formatter.format(_sum)}
                                                            </td>
                                                        </tr>
                                                    </Table>
                                                </td>
                                            </tr>
                                        </Col>
                                    </Row>


                                </Col>}
                            </Row>
                            <Row className='pt-3'>
                                <Col sm="6">
                                    <label className='f-w-600'>
                                        <label className='f-w-600 txt-info'>Fecha y hora de autorización:</label> <br />
                                        <label style={{ marginLeft: '5px', fontSize: "12px" }}>{_new ?? "---------"}</label>
                                    </label>
                                </Col>
                                <Col sm="6" style={{ textAlign: "end" }}>
                                    <label className='f-w-600'>
                                        <label className='f-w-600 txt-info'>Responsable de autorizar corte:</label> <br />
                                        <label style={{ marginLeft: '5px', fontSize: "11px" }}>{_nameUser ?? "---------"}</label>
                                    </label>
                                </Col>
                            </Row>
                        </Col>
                    }
                    {
                        _admin_cash !== "True" && <Col sm="12" style={{ textAlign: "center" }} className='p-l-0 p-r-0 '>
                            <img className="img-fluid" src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "80%" }} alt="" />
                            <br />
                            <p className='f-w-600 f-14 badge badge-light-danger' >Contacte a Administracion.</p>
                        </Col>
                    }



                </Form>



            </Col>
        </Dialog>

    )
}
